import { Helmet } from 'react-helmet-async';
import EditClinicProductView from 'src/sections/clinic-dashboard/products/products-edit-view';

export default function ClinicEditProductPage() {
  return (
    <>
      <Helmet>
        <title>Edit Product</title>
      </Helmet>

      <EditClinicProductView />
    </>
  );
}
